// src/components/purchase/UnitPicker.js
// D-291 (Stabilization P3c-7) - the Unit box of a PO line, ONE component for
// Direct PO and Amend PO.
//
//   locked = true  -> the item is from Item Master and Item Master has a unit:
//                     shown read-only, saved exactly as Item Master has it
//                     (the GRN compares it with the item's purchase_unit).
//   locked = false -> custom item, or an Item Master item without a unit:
//                     the shared list (units.js UNIT_OPTIONS). A blank unit
//                     is refused on save by checkPOLines().
//   masterNoUnit   -> amber hint: fix the item in Item Master as well.
//
// No Firestore here - display only.
import React from "react";
import { unitOptionsFor, hasUnit } from "../../utils/units";

export default function UnitPicker({ value, locked = false, masterNoUnit = false, disabled = false, onChange, className = "" }) {
  if (locked && hasUnit(value)) {
    return (
      <div title="Unit from Item Master" data-testid="unit-locked"
        className={`w-full min-w-[130px] px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-700 ${className}`}>
        {value}
      </div>
    );
  }
  const missing = !hasUnit(value);
  return (
    <div>
      <select value={value || ""} disabled={disabled} onChange={(e) => onChange && onChange(e.target.value)}
        data-testid="unit-select"
        className={`w-full min-w-[130px] px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-indigo-300 outline-none bg-white disabled:bg-gray-100 ${
          missing ? "border-amber-300 text-gray-400" : "border-gray-300 text-gray-800"
        } ${className}`}>
        <option value="" disabled>Select unit</option>
        {unitOptionsFor(value).map((u) => <option key={u} value={u}>{u}</option>)}
      </select>
      {masterNoUnit && !disabled && (
        <p className="text-xs text-amber-600 mt-1">No unit in Item Master - pick one (and add it in Item Master)</p>
      )}
    </div>
  );
}